import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import QuickChannels from "./components/QuickChannels";
import HotRank from "./components/HotRank";
import LatestReleases from "./components/LatestReleases";
import FeaturedPicks from "./components/FeaturedPicks";
import DownloadGuide from "./components/DownloadGuide";
import Changelog from "./components/Changelog";
import SafeTrust from "./components/SafeTrust";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950">
      <TopNav />
      <main>
        <Hero />
        <QuickChannels />
        <HotRank />
        <LatestReleases />
        <FeaturedPicks />
        <DownloadGuide />
        <Changelog />
        <SafeTrust />
      </main>
      <SiteFooter />
    </div>
  );
}